/* CROSSBAR KITS · v3 interactions (hero, rails, tabs, ticker) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Hero slider ---------- */
  function initHero(root) {
    var slides = [].slice.call(root.querySelectorAll('.cb-slide'));
    var tabs = [].slice.call(root.querySelectorAll('.cb-hero__tab'));
    if (slides.length < 2) return;
    var dur = parseInt(root.getAttribute('data-duration') || '7000', 10);
    root.style.setProperty('--cb-dur', dur + 'ms');
    var i = 0, timer = null, paused = false;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.querySelectorAll('a,button').forEach(function (el) { el.tabIndex = on ? 0 : -1; });
      });
      tabs.forEach(function (t, k) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', k === i ? 'true' : 'false');
        if (k === i) { void t.offsetWidth; t.classList.add('is-active'); }
      });
      // lazy image of the next slide
      var nx = slides[(i + 1) % slides.length].querySelector('img[data-src]');
      if (nx) { nx.src = nx.getAttribute('data-src'); nx.removeAttribute('data-src'); }
      schedule();
    }
    function schedule() {
      clearTimeout(timer);
      if (reduce || paused) return;
      timer = setTimeout(function () { go(i + 1); }, dur);
    }
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    root.addEventListener('mouseenter', function () { paused = true; root.classList.add('is-paused'); clearTimeout(timer); });
    root.addEventListener('mouseleave', function () { paused = false; root.classList.remove('is-paused'); schedule(); });
    root.addEventListener('focusin', function () { paused = true; clearTimeout(timer); });
    // swipe
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(i + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
    document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(timer); else schedule(); });
    go(0);
  }

  /* ---------- Rails ---------- */
  function initRail(rail) {
    var track = rail.querySelector('.cb-rail__track');
    var prev = rail.querySelector('.cb-rail__btn--prev');
    var next = rail.querySelector('.cb-rail__btn--next');
    if (!track) return;
    function upd() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft < 8;
      next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8;
    }
    function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: reduce ? 'auto' : 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  /* ---------- Tabs (league filter over one product set) ---------- */
  function initTabs(root) {
    var tabs = [].slice.call(root.querySelectorAll('.cb-tab'));
    var items = [].slice.call(root.querySelectorAll('[data-league]'));
    var more = root.querySelector('[data-cb-more]');
    var limit = parseInt(root.getAttribute('data-limit') || '10', 10);
    function show(t) {
      var key = t.getAttribute('data-key');
      tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
      var n = 0;
      items.forEach(function (el) {
        var ok = key === 'all' || el.getAttribute('data-league') === key || (key === 'other' && el.getAttribute('data-big') !== '1');
        if (ok && n < limit) { el.hidden = false; n++; } else { el.hidden = true; }
      });
      if (more) {
        more.href = t.getAttribute('data-url');
        var lbl = more.querySelector('[data-cb-more-label]');
        if (lbl) lbl.textContent = t.getAttribute('data-label');
      }
      var track = root.querySelector('.cb-rail__track');
      if (track) { track.scrollLeft = 0; track.dispatchEvent(new Event('scroll')); }
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t); }); });
    if (tabs[0]) show(tabs[0]);
  }

  /* ---------- Ticker (mobile rotation) ---------- */
  function initTicker(root) {
    var msgs = [].slice.call(root.querySelectorAll('.cb-ticker__msg'));
    if (msgs.length < 2) return;
    var i = 0;
    msgs[0].classList.add('is-on');
    if (reduce) return;
    setInterval(function () {
      if (window.innerWidth >= 1360) return;
      msgs[i].classList.remove('is-on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
    }, 3800);
  }

  function boot() {
    document.querySelectorAll('[data-cb-hero]').forEach(initHero);
    document.querySelectorAll('[data-cb-rail]').forEach(initRail);
    document.querySelectorAll('[data-cb-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-cb-ticker]').forEach(initTicker);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* v4 · parallax hero, 3D tilt cards, scroll reveal */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (reduce) return;
  function parallax(root) {
    if (!fine || root.dataset.cbPx) return; root.dataset.cbPx = '1';
    var raf = null, tx = 0, ty = 0;
    root.addEventListener('mousemove', function (e) {
      var r = root.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - 0.5) * 2; ty = ((e.clientY - r.top) / r.height - 0.5) * 2;
      if (!raf) raf = requestAnimationFrame(function () { root.style.setProperty('--mx', tx.toFixed(3)); root.style.setProperty('--my', ty.toFixed(3)); raf = null; });
    });
    root.addEventListener('mouseleave', function () { root.style.setProperty('--mx', 0); root.style.setProperty('--my', 0); });
  }
  function tilt(card) {
    if (!fine || card.dataset.cbTilt) return; card.dataset.cbTilt = '1';
    var media = card.querySelector('.cb-card__media'); if (!media) return;
    if (!media.querySelector('.cb-card__shine')) { var s = document.createElement('span'); s.className = 'cb-card__shine'; media.appendChild(s); }
    media.addEventListener('mousemove', function (e) {
      var r = media.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      card.classList.add('is-tilting');
      media.style.transform = 'perspective(800px) rotateX(' + ((0.5 - y) * 9).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * 11).toFixed(2) + 'deg) translateZ(0)';
      media.style.setProperty('--sx', (x * 100).toFixed(1) + '%'); media.style.setProperty('--sy', (y * 100).toFixed(1) + '%');
    });
    media.addEventListener('mouseleave', function () { card.classList.remove('is-tilting'); media.style.transform = ''; });
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  function boot() {
    document.querySelectorAll('[data-cb-parallax]').forEach(parallax);
    document.querySelectorAll('.cb-card').forEach(tilt);
    if (io) document.querySelectorAll('.cb-home .cb-sec .cb-head, .cb-home .cb-offer, .cb-home .cb-clubs__grid, .cb-home .cb-leagues, .cb-home .cb-why').forEach(function (el) {
      if (el.classList.contains('cb-reveal') || el.dataset.cbRv) return;
      el.dataset.cbRv = '1';
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      el.classList.add('cb-reveal'); io.observe(el);
    });
    setTimeout(function () { document.querySelectorAll('.cb-reveal:not(.is-in)').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight * 1.2) el.classList.add('is-in'); }); }, 1500);
    window.addEventListener('scroll', function () { document.querySelectorAll('.cb-reveal:not(.is-in)').forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight * 0.95) el.classList.add('is-in'); }); }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  var mq = null; new MutationObserver(function () { if (mq) return; mq = setTimeout(function () { mq = null; document.querySelectorAll('.cb-card:not([data-cb-tilt])').forEach(tilt); }, 300); }).observe(document.documentElement, { childList: true, subtree: true });
})();
